export const statusPhone = [
    { value: "production", text: "Production" },
    { value: "free", text: "Free" },
    { value: "preprod_customers", text: "Preprod customers" },
    { value: "tests_customers", text: "Tests customers" },
    { value: "tests_internal", text: "Tests internal" },
]


export function getStatusNameByValue(value) {
    const status = statusPhone.find((s) => s.value === value);
    return status ? status.text : "-";
}